var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[(_vm.student.avatar)?_c('img',{staticClass:"student-avatar",attrs:{"src":_vm.urlProxy(_vm.student.avatar)}}):_c('div',{staticClass:"def-avatar"},[_vm._v(_vm._s(_vm.iconname))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }